import React from 'react';
import PosRouter from './router/PosRouter';
import Layout from '../../../components/Layout';
import styled from 'styled-components';

const MainContentWrapper = styled.div`
  height: calc(100% - 40px);
  padding: 20px;
`;

const PosPage = () => {
  return (
    <Layout showOpenCashDrawer>
      <MainContentWrapper>
        <PosRouter />
      </MainContentWrapper>
    </Layout>
  );
};

export default PosPage;
